export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
            关于暗网吃瓜
          </h2>
          <div className="bg-background-200/80 border border-background-300/30 rounded-2xl p-8 md:p-10">
            <div className="w-16 h-16 mx-auto flex items-center justify-center bg-primary-500 rounded-2xl mb-6">
              <i className="ri-spy-line text-2xl text-background-50"></i>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              暗网吃瓜创立于 2024 年，是国内领先的黑料查询与爆料聚合平台。
              我们致力于打造一个开放、高效、安全的信息共享空间，通过智能检索技术与社区协作机制，
              帮助用户快速发现、追踪和讨论全网最新爆料事件。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              平台覆盖娱乐圈、网红圈、科技圈、商业圈、体育圈等十余个垂直领域，
              每日由专业编辑团队与社区成员共同维护数千条爆料条目的更新。
              我们坚持「快速、准确、全面」的内容理念，同时严格保护投稿人隐私与信息来源安全。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              暗网吃瓜所有内容均源自公开信息聚合与用户匿名投稿，平台不对爆料内容的真实性承担法律责任。
              如涉及侵权内容，请通过官方渠道联系我们进行核实处理。吃瓜有度，理性讨论。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}